<script setup>
const items = [
  {
    titulo: "CRUD Cadastro de pessoa",
    img: "crud-cadastro-pessoa=vue.jpeg",
    nome: "Cadastro de pessoas",
    link: "https://crud-cadastro-pessoa-vue-1d67c4ji7-gutim160.vercel.app",
    tecnologia: ["Vue.js"],
  },
  {
    titulo: "Gerencia Senhas",
    img: "gerencia-senha-quasar.jpeg",
    link: "https://gerencia-senhas-quasar.vercel.app",
    tecnologia: ["Quasar", "Firebase"],
  },
  {
    titulo: "TODO",
    img: "todo-tarefa-vue.jpeg",
    nome: "TODO",
    link: "https://todo-tarefas-vue.vercel.app",
    tecnologia: ["Vue.js"],
  },
  {
    titulo: "Cauculadora",
    img: "calculadora-vue.jpeg",
    link: "https://calculator-vue-rho.vercel.app",
    tecnologia: ["Vue.js"],
  },
  {
    titulo: "Dashboard - DevSuperior",
    img: "dashboard-spring-react.jpeg",
    link: "https://devsuperio-augustooliveira.netlify.app",
    tecnologia: ["React", "SpringBoot"],
  },
  {
    titulo: "Loja Virtual",
    img: "loja-virtual-quasar.jpeg",
    link: "https://loja-virual.netlify.app",
    tecnologia: ["Quasar", "Supabase", "responsivo"],
  },
  {
    titulo: "Pesquisa filmes",
    img: "pesquisa-filmes.jpeg",
    link: "https://pesquisa-filmes.netlify.app/",
    tecnologia: ["Vue.js", "Vuetify", "OMDb API RESTful"],
  },
  {
    titulo: "Emissão automática de notas fiscais para infoprodutores",
    descricao:
      "Software de emissão automática de notas fiscais para infoprodutores com SPLIT Fiscal e coprodução.",
    img: "wisenotas-nf.jpeg",
    link: "https://app.wisenotas.com/",
    tecnologia: ["Quasar", "Laravel 7", "Vue.js"],
  },
  {
    titulo: "E-commecer de produtos digitais.",
    descricao:
      "E-commecer de produtos digitais.",
    img: "ecommece-react-tailwind.png",
    link: "https://e-commerce-shop-react-tailwind.vercel.app/",
    tecnologia: ["React", "Tailwind"],
  },
  {
    titulo: "E-commecer Shopping Cart",
    descricao:
      "E-commecer Shopping Cart. Para vendas de delivere.",
    img: "shopping-cart-react.png",
    link: "https://shopping-cart-react-chi.vercel.app/",
    tecnologia: ["React", "Boosstrap"],
  },
  {
    titulo: "Todo List",
    descricao:
      "Todo List. Para controlar suas tarefas.",
    img: "Todo-list-react.png",
    link: "https://todo-list-react-nu-teal.vercel.app/",
    tecnologia: ["React"],
  },
  {
    titulo: "Quiz React",
    descricao:
      "Quiz React. Para testar seus conhecimentos.",
    img: "quiz-react.png",
    link: "https://quiz-app-react-blond.vercel.app/",
    tecnologia: ["React"],
  },
  {
    titulo: "Simples tela de login",
    descricao:
      "Simples tela de login. Para testar seus conhecimentos.",
    img: "simples-tela-login-html-css.png",
    link: "https://tela-login-curso-fullstack-hotmart.vercel.app/",
    tecnologia: ["HTML", "CSS"],
  },
  {
    titulo: "Busca usuário GitHub React",
    descricao:
      "Busca usuário GitHub.",
    img: "find-user-github-react.png",
    link: "https://gihub-finder-react.vercel.app/",
    tecnologia: ["React", "CSS", "API GitHub"],
  },
  {
    titulo: "Busca usuário GitHub VueJS",
    descricao:
      "Busca usuário GitHub.",
    img: "busca-usuario-github-vuejs.png",
    link: "https://consumer-api-github-vuejs.vercel.app/",
    tecnologia: ["VueJS", "CSS", "API GitHub"],
  },
  {
    titulo: "Simples Editor de imagem",
    descricao:
      "Simples Editor de imagem.",
    img: "simples-editor-imagem-html-css-js.png",
    link: "https://draw-paint-app.vercel.app/",
    tecnologia: ["HTML", "CSS", "JavaScript"],
  },
  {
    titulo: "Simples jogo de palavra Cruzada",
    descricao:
      "Simples jogo de palavra Cruzada.",
    img: "jogo-palavra-crusada-html-css-js.png",
    link: "https://word-scramble-game-html-css-js.vercel.app/",
    tecnologia: ["HTML", "CSS", "JavaScript"],
  },
  {
    titulo: "Website Food",
    descricao:
      "Website Food. para pedidos de comida.",
    img: "page-web-food-html-css-js.png",
    link: "https://website-food-six.vercel.app/",
    tecnologia: ["HTML", "CSS", "JavaScript"],
  },
  {
    titulo: "Restaurante Food",
    descricao:
      "Restaurante Food. para pedidos de comida.",
    img: "restaurante-food-html-css-js.png",
    link: "https://restaurant-food-menu.vercel.app/",
    tecnologia: ["HTML", "CSS", "JavaScript"],
  },
  {
    titulo: "Custom Play Videos",
    descricao:
      "Custom Play Videos. para visualizar videos.",
    img: "custom-play-videos-html-css-js.png",
    link: "https://custom-videoplay-html-css-js.vercel.app/",
    tecnologia: ["HTML", "CSS", "JavaScript"],
  },
  {
    titulo: "Simples Resize Imagens",
    descricao:
      "Simples Resize Imagens. para redimensionar imagens.",
    img: "simples-resize-imagens-html-css-js.png",
    link: "https://resize-compress-image-html-css-js.vercel.app/",
    tecnologia: ["HTML", "CSS", "JavaScript"],
  },
  {
    titulo: "Step de avaliação",
    descricao:
      "Simples Step de avaliação",
    img: "step-avaliacao-react.png",
    link: "https://steps-payment-react.vercel.app/",
    tecnologia: ["React"],
  },
];
</script>

<template>
  <v-col cols="12" sm="12" id="projetos">
    <div class="d-flex justify-center mb-6">
      <v-btn color="red" class="mr-2">All</v-btn>
      <v-btn color="red-1" class="mr-2" variant="tonal">VueJS</v-btn>
      <v-btn class="mr-2" variant="tonal">Quasar</v-btn>
      <v-btn class="mr-2" variant="tonal">React</v-btn>
      <v-btn class="mr-2" variant="tonal">HTML/CSS/JS</v-btn>
    </div>
  </v-col>
  <v-col cols="12" class="">
    <v-row class="fill-height" align="center" justify="center">
      <template v-for="(item, i) in items" :key="i">
        <v-col cols="12" md="4">
          <v-hover v-slot="{ isHovering, props }">
            <v-card
              :elevation="isHovering ? 12 : 2"
              :class="{ 'on-hover': isHovering }"
              v-bind="props"
              min-height="400px"
            >
              <v-img :src="item.img" height="225px" cover> </v-img>
              <v-row class="mt-2 ml-1">
                <v-col v-for="tec in item.tecnologia" :key="tec">
                  <v-chip color="green">{{ tec }}</v-chip>
                </v-col>
              </v-row>
              <v-card-title class="d-flex justify-center">{{
                item.titulo
              }}</v-card-title>
              <v-card-subtitle v-if="item.titulo === 'Gerencia Senhas'">
                <strong>Email:</strong> teste@email.com <br />
                <strong>Senha:</strong> 123456
              </v-card-subtitle>
              <v-card-subtitle v-if="item.titulo === 'Loja Virtual'">
                <strong>Email:</strong> usuario@teste.com <br />
                <strong>Senha:</strong> 123456789
              </v-card-subtitle>
              <v-card-actions class="d-flex justify-center">
                <a
                  target="_blank"
                  style="text-decoration: none"
                  :href="item.link"
                >
                  <v-btn color="red" variant="tonal"> View </v-btn>
                </a>
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-col>
      </template>
    </v-row>
  </v-col>
</template>

<style scoped>

.imgHover {
  padding: 0 200px;
}
</style>
